import {
  isClassicFeDispatch,
  resolveRoleWeights,
} from "../../sim/relationProfile";
import { rechooseRoles, woodsStep, woodsStepRoles } from "../../sim/step";
import type { ModelPlugin } from "../types";

/**
 * Woods friends/enemies model — single implementation path via sim/step.ts
 * so golden tests and the live exhibit stay bit-aligned.
 *
 * classic_fe always uses fused woodsStep (Track R A3).
 */
export const friendsEnemiesModel: ModelPlugin = {
  id: "friends_enemies",
  label: "Friends & enemies",
  tier: "basic",
  description: "Woods step: x ← c x + ps f(p) − qs f(q)",
  step({
    params,
    positions,
    outPositions,
    friends,
    enemies,
    targets,
    roleCount,
    roleWeights,
    types,
    scratchA,
    scratchB,
    rng,
    spatialHash,
  }) {
    rechooseRoles(
      targets,
      friends.length,
      roleCount,
      params,
      rng,
      types ?? null,
      {
        positions,
        spatialHash,
      },
    );

    if (isClassicFeDispatch(params.relationProfile) && roleCount >= 2) {
      // Fused path — golden bit-identical (ignore roleWeights; friend/enemy steps SoT)
      woodsStep(
        positions,
        friends,
        enemies,
        params,
        outPositions,
        scratchA,
        scratchB,
      );
    } else {
      const w = roleWeights ?? resolveRoleWeights(params);
      woodsStepRoles(
        positions,
        targets,
        w,
        friends.length,
        roleCount,
        params.dim,
        params.contraction,
        params.softening,
        outPositions,
        scratchA,
      );
    }
  },
};
